import {
	EmailCard,
	type EmailEntry,
	ThreadCard,
	groupByThread,
} from "@/components/email-thread";
import { api } from "@/lib/api";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";

// ============================================================
// Booking Detail — Emails Tab (Thread-basierte Ansicht)
// ============================================================

export function EmailsTab({ bookingId }: { bookingId: string }) {
	const query = useQuery({
		queryKey: ["booking-emails", bookingId],
		queryFn: () =>
			api.get<{ data: EmailEntry[] }>(`/bookings/${bookingId}/emails`),
	});

	const emails = query.data?.data ?? [];
	const threads = groupByThread(emails);

	if (query.isLoading) {
		return (
			<div className="flex justify-center py-8">
				<Loader2 className="h-6 w-6 animate-spin text-stone-400" />
			</div>
		);
	}

	if (threads.length === 0) {
		return (
			<div className="text-center py-12 text-stone-400">
				Noch keine E-Mails verknüpft.
			</div>
		);
	}

	return (
		<div className="space-y-3">
			<div className="flex items-center justify-between">
				<span className="text-xs text-stone-400">
					{emails.length} E-Mail{emails.length !== 1 ? "s" : ""} in{" "}
					{threads.length} Thread{threads.length !== 1 ? "s" : ""}
				</span>
			</div>

			{threads.map((thread) => (
				<ThreadCard key={thread.threadId} thread={thread}>
					{thread.emails.map((email, idx) => (
						<EmailCard
							key={email.id}
							email={email}
							isLast={idx === thread.emails.length - 1}
						/>
					))}
				</ThreadCard>
			))}
		</div>
	);
}
